import type { FC } from 'react'
import { QuickActionPanelType } from '@chegg-wt/core-wa/types'
import { getWordCount } from '@chegg-wt/core-wa/utils/helpers'
import { QuickActionRightPanelSubHeading } from '../styled'
import { QuickActionRightPanelSubheadingProps } from '../types'

const getQuickActionRightPanelSubheading = (
  quickActionPanelType: QuickActionPanelType,
  wordCountDiff: number
): JSX.Element => {
  return (
    <QuickActionRightPanelSubHeading>
      This {quickActionPanelType === QuickActionPanelType.EXPAND ? 'expands' : 'shortens'}{' '}
      your writing by {wordCountDiff} {wordCountDiff === 1 ? 'word.' : 'words.'}
    </QuickActionRightPanelSubHeading>
  )
}

// Handles Subheading for all 3 cases expand, shorten, paraphrase on the basis of text length inside the Quick Action Panel
export const QuickActionRightPanelSubheading: FC<QuickActionRightPanelSubheadingProps> = ({
  originalText,
  suggestedText,
  quickActionPanelType,
}: QuickActionRightPanelSubheadingProps) => {
  const originalTextWordCount = getWordCount(originalText)
  const suggestedTextWordCount = getWordCount(suggestedText)

  if (quickActionPanelType === QuickActionPanelType.PARAPHRASE) {
    let wordCountDiff = originalTextWordCount - suggestedTextWordCount

    if (wordCountDiff === 0) return null

    if (suggestedTextWordCount > originalTextWordCount) {
      wordCountDiff = suggestedTextWordCount - originalTextWordCount
      return getQuickActionRightPanelSubheading(
        QuickActionPanelType.EXPAND,
        wordCountDiff
      )
    }
    return getQuickActionRightPanelSubheading(QuickActionPanelType.SHORTEN, wordCountDiff)
  }

  // QuickActionPanelType is Expand/Shorten

  const wordCount: number =
    quickActionPanelType === QuickActionPanelType.SHORTEN
      ? originalTextWordCount - suggestedTextWordCount
      : suggestedTextWordCount - originalTextWordCount

  const isMismatch =
    quickActionPanelType === QuickActionPanelType.SHORTEN
      ? suggestedTextWordCount >= originalTextWordCount
      : originalTextWordCount >= suggestedTextWordCount

  return (
    !isMismatch &&
    getQuickActionRightPanelSubheading(
      (quickActionPanelType as unknown) as QuickActionPanelType,
      wordCount
    )
  )
}

export const isExpandShortenResultMismatch = ({
  originalText,
  suggestedText,
  quickActionPanelType,
}: QuickActionRightPanelSubheadingProps) => {
  const originalTextWordCount = getWordCount(originalText)
  const suggestedTextWordCount = getWordCount(suggestedText)

  return quickActionPanelType === QuickActionPanelType.SHORTEN
    ? suggestedTextWordCount > originalTextWordCount + 2
    : originalTextWordCount > suggestedTextWordCount + 2
}
